import initTlog from '../../../common/js/tlog'

// 临时使用tlog统计，后期由思雨兼容百中处理

initTlog({
  exposure: [{
    // 6大行业模块-职位卡片
    async: true,
    type: 'dynamic',
    container: {
      xpath: 'section.home-industry-container',
    },
    xpath: 'section.home-industry-container/div.home-industry-box/div.home-industry-content-container/div.home-industry-content/div.home-industry-content-list/div.home-industry-content-item',
  },{
    // 6大行业模块-热门公司
    async: true,
    type: 'dynamic',
    container: {
      xpath: 'section.home-industry-container',
    },
    xpath: 'section.home-industry-container/div.home-industry-box/div.home-industry-content-container/div.home-industry-content/div.home-industry-content-comp/a.industry-content-comp-item',
   },{
    // 名企职位模块
    async: true,
    type: 'dynamic',
    container: {
      xpath: 'div.home-comp-container',
    },
    xpath: 'div.home-comp-container/div.home-comp-content/div.home-comp-content-item',
  }],
}, true);

